// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-detail-table[data-v-495d7196] .yellow-row {\n  background-color: #ffff00d4;\n}\n.report-detail-table[data-v-495d7196] .red-row {\n  background-color: #ff0000c9;\n  color: #fff;\n}\n.report-detail-table[data-v-495d7196] .red-row:hover {\n    color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
